import React from 'react';
import PropTypes from 'prop-types';
import { AgreementDetailsManagementComponents } from '../AgreementDetailsManagementComponents';

export const AgreementDetailsContentDialog = ({
  parentTranslationPath,
  translationPath,
  state,
  setState,
  selected,
  setSelected,
  contactReletedWithDeveloperId,
  agreementValidityStatus,
  setIsHideFiled,
  isHideFiled,
}) => {
  const onChangeHandler = (key, values, selectedObj, selectedValues) => {
    if (!selectedObj) {
      setState({ id: [key], value: values });
    } else {
      setState({ id: [key], value: values });
      setSelected({ id: [selectedObj], value: selectedValues });
    }
  };

  return (
    <div className='dialog-content-wrapper'>
      <AgreementDetailsManagementComponents
        translationPath={translationPath}
        parentTranslationPath={parentTranslationPath}
        state={state}
        setState={setState}
        selected={selected}
        onChangeHandler={onChangeHandler}
        className={'dialog-content-item'}
        editForm
        contactReletedWithDeveloperId={contactReletedWithDeveloperId}
        agreementValidityStatus={agreementValidityStatus}
        isHideFiled={isHideFiled}
        setIsHideFiled={setIsHideFiled}
      />
    </div>
  );
};

AgreementDetailsContentDialog.propTypes = {
  parentTranslationPath: PropTypes.string.isRequired,
  translationPath: PropTypes.string.isRequired,
  state: PropTypes.instanceOf(Object).isRequired,
  setState: PropTypes.func.isRequired,
};
